import { z } from 'zod/v3';

export const IDENTITY_AUDIT_EVENT_SCHEMA_VERSION = 1;

const IdentityAuditActor = z.object({
  externalId: z.string().nullable(),
  displayName: z.string().nullable(),
  type: z.enum(['user', 'service', 'system', 'unknown']),
});

const IdentityAuditTarget = z.object({
  externalId: z.string().nullable(),
  displayName: z.string().nullable(),
  type: z.string().nullable(),
});

export const IdentityAuditEvent = z.object({
  externalId: z.string(),
  eventType: z.string(),
  category: z.enum([
    'user_lifecycle',
    'privileged_access',
    'authentication',
    'policy_change',
    'token_lifecycle',
    'unknown',
  ]),
  outcome: z.enum(['success', 'failure', 'unknown']),
  actor: IdentityAuditActor,
  targets: z.array(IdentityAuditTarget),
  occurredAt: z.string().datetime(),
  clientIp: z.string().nullable(),
});

export type IdentityAuditEvent = z.infer<typeof IdentityAuditEvent>;
